import { gql } from '@apollo/client';
import {
  COORDINATES_3D_FIELDS,
  COORDINATES_FIELDS,
  DIMENSIONS_3D_FIELDS,
  IMAGE_FIELDS,
  MEDIA_FIELDS,
  MONEY_FIELDS,
  SHAPE_FIELDS,
  TRANSLATED_STRING_FIELDS
} from './common';

export const EDITABLE_SIDE_FIELDS = gql`
  ${SHAPE_FIELDS}
  fragment EditableSideFields on EditableSide {
    side
    shape {
      ...ShapeFields
    }
  }
`;

export const EDITABLE_AREA_FIELDS = gql`
  ${COORDINATES_FIELDS}
  ${COORDINATES_3D_FIELDS}
  ${SHAPE_FIELDS}
  fragment EditableAreaFields on EditableArea {
    id
    shape {
      ...ShapeFields
    }
    side
    outlineCenter {
      ...CoordinatesFields
    }
    engravingCenter {
      ...CoordinatesFields
    }
    surfaceNormal {
      ...Coordinates3DFields
    }
  }
`;

export const PIECE_CONFIGURATION_FIELDS = gql`
  fragment PieceConfigurationFields on PieceConfiguration {
    sizeType
    materialType
    platingType
    stonesPlacementType
  }
`;

export const PIECE_REFERENCE_FIELDS = gql`
  ${PIECE_CONFIGURATION_FIELDS}
  fragment PieceReferenceFields on PieceReference {
    pieceId
    pieceModelId
    pieceConfiguration {
      ...PieceConfigurationFields
    }
  }
`;

export const PIECE_WEIGHT_FIELDS = gql`
  ${PIECE_CONFIGURATION_FIELDS}
  fragment PieceWeightFields on PieceWeight {
    configuration {
      ...PieceConfigurationFields
    }
    weightInGrams
  }
`;

export const PIECE_IMAGE_FIELDS = gql`
  ${PIECE_CONFIGURATION_FIELDS}
  ${IMAGE_FIELDS}
  fragment PieceImageFields on PieceImage {
    configuration {
      ...PieceConfigurationFields
    }
    image {
      ...ImageFields
    }
  }
`;

export const PIECE_MODEL_FIELDS = gql`
  ${EDITABLE_SIDE_FIELDS}
  ${EDITABLE_AREA_FIELDS}
  ${SHAPE_FIELDS}
  ${DIMENSIONS_3D_FIELDS}
  ${PIECE_CONFIGURATION_FIELDS}
  ${PIECE_WEIGHT_FIELDS}
  ${PIECE_IMAGE_FIELDS}
  ${MEDIA_FIELDS}
  fragment PieceModelFields on PieceModel {
    id
    editableSides {
      ...EditableSideFields
    }
    editableAreas {
      ...EditableAreaFields
    }
    stonesPlacementType
    cadFile {
      ...MediaFields
    }
    sizeType
    dimensions {
      ...Dimensions3DFields
    }
    icon {
      ...MediaFields
    }
    availableConfigurations {
      ...PieceConfigurationFields
    }
    weights {
      ...PieceWeightFields
    }
    images {
      ...PieceImageFields
    }

    isPublishable
    hasDimensionsValid
    hasOutlineValid
    hasIconValid
    hasCadFileValid
    hasEditableAreasValid
    hasAvailableConfigurationsValid
    hasWeightsValid
    hasImagesValid
  }
`;

export const PIECE_FIELDS = gql`
  ${TRANSLATED_STRING_FIELDS}
  ${PIECE_MODEL_FIELDS}
  fragment PieceFields on Piece {
    id
    title {
      ...TranslatedStringFields
    }
    description {
      ...TranslatedStringFields
    }
    geometryType
    models {
      ...PieceModelFields
    }
    isPublishable
  }
`;

export const PRICE_PIECE_FIELDS = gql`
  ${PIECE_REFERENCE_FIELDS}
  ${MONEY_FIELDS}
  fragment PricePieceFields on PricePiece {
    pieceReference {
      ...PieceReferenceFields
    }
    price {
      ...MoneyFields
    }
  }
`;

export const PIECE_ASSET_FIELDS = gql`
  ${PIECE_FIELDS}
  fragment PieceAssetFields on PieceAsset {
    id
    ownerPartyId
    public
    piece {
      ...PieceFields
    }
    createdAt
    updatedAt

    isPublishable
  }
`;
